import config from "../config/config";
import { Environment, EnvironmentConfig } from "../models/environment";
import { GetEnvironments, getDefaultEnvironments 

} from "../environments/environment";
import { useEffect, useState } from "react";
const envs: Environment[] = GetEnvironments();
const env_default = getDefaultEnvironments();
function getConfigs(query: URLSearchParams, path: string): EnvironmentConfig {
    const configs = config(envs)
    const configs_default = config(env_default);
    let configFiltered = configs.filter((c) => {
        return isAnAllowed(c, path) && containsAllMandatoryProperties(c, query);
    })[0] || configs_default[0];
    return configFiltered;
}

function isAnAllowed(config: EnvironmentConfig, path: string): boolean {

    return config.allowed_paths.some((allowedPath: string) => path.startsWith(allowedPath) || allowedPath === "*");
}

function containsAllMandatoryProperties(config: EnvironmentConfig, query: URLSearchParams): boolean {
    let is_valid: boolean = true;
    for (const [key, values] of Object.entries(config.mandatory_properties)) {
        if (!values.includes(query.get(key) || '')) {
            is_valid = false;
        }
    }
    return is_valid;
}
function useConfig(): EnvironmentConfig {
    const [path, setPath] = useState(window.location.pathname || "");
    const [query_str, setQueryStr] = useState(window.location.search || "");
    const [configValue, setConfigValue] = useState<EnvironmentConfig>(
        getConfigs(new URLSearchParams(query_str), path)
    );

    useEffect(() => {
        const updatePath = () => {
            setPath(window.location.pathname || "");
        };

        const updateQuery = () => {
            const newQueryStr = window.location.search || "";
            setQueryStr(newQueryStr);
            setConfigValue(getConfigs(new URLSearchParams(newQueryStr), path));
        };

        const unlistenPath = () =>
            window.removeEventListener('click', updatePath);

        const unlistenQuery = () =>
            window.removeEventListener('click', updateQuery);

        window.addEventListener('click', updatePath);
        window.addEventListener('click', updateQuery);

        return () => {
            unlistenPath();
            unlistenQuery();
        };
    }, [path, query_str]);

    return configValue;
}

export default useConfig;